import React, {useState} from "react"
import {FieldViewSize} from "../../../../../const";

// const debug = false
const debug = "FieldTimeReported_InlineValueNotEmpty"

export default function FieldTimeReported_InlineValueNotEmpty(props:any) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onChange(null);
    }


    const className = Classes("ui5-field-editable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    const valueFormatted = props.field.getDisplayValue(props.value)


    const valueClass = Classes('txt-truncate', {
        'ui5-txt-default'                   : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'      : size === FieldViewSize.SMALL,
    })

    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                    <div className={valueClass}>{valueFormatted}</div>
                    <div className="buttons">
                        {props.field.clearButton && <div className="btn-reset" onClick={onDeleteClick}/>}
                        {/*<div className="btn-arrow"/>*/}
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>
            <div className={Classes(className, valueClass)} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {valueFormatted}
            </div>
            {props.children}
        </React.Fragment>
    )


    //
    //
    // const onDeleteClick = () => {
    //     props.onChange(null);
    // }
    //
    // debug && console.log(debug, 'render', gd.utils.minutesHumanize(props.value), props.value)
    //
    // return (
    //     <React.Fragment>
    //         <div className="ui5-field-with-delete-on-hover">
    //             <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
    //                 {gd.utils.minutesHumanize(props.value)}
    //             </div>
    //
    //             {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
    //         </div>
    //         {props.children}
    //     </React.Fragment>
    // )
}
